import request from "../request";

export async function getUploadFile(params) {
  return request({
    // url: '/upload/file',
    url: "/upload/file_by_not",
    method: "post",
    data: params,
  });
}

export async function getUploadFile_by_not(params) {
  return request({
    url: "/upload/file_by_not",
    method: "post",
    data: params,
  });
}

export async function delete_file(params) {
  return request({
    url: "/upload/delete_file",
    method: "post",
    data: params,
  });
}

export async function getHeaderList(params) {
  return request({
    url: "/article/get_header_ad_list",
    method: "post",
    data: params,
  });
}

export async function gemMiddleList(params) {
  return request({
    url: "/article/get_middle_ad_list",
    method: "post",
    data: params,
  });
}

/**
 * 商品分类
 * @param params
 * @returns {Promise<Promise<*> | *>}
 */

export async function getCategoryFn(params) {
  return request({
    url: "/pc/category/list",
    method: "post",
    data: params,
  });
}

/**
 * 商品分类
 * @param params
 * @returns {Promise<Promise<*> | *>}
 */

export async function createQrCode(params) {
  return request({
    url: "/user/createQrCode",
    method: "post",
    data: params,
  });
}
